import React from "react";
/** composants **/
import { Navbar } from '../Navbar';
import Footer from '../components/Footer';
import FaqMariage from '../components/CinqQuestionsMariage';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
//img & icon
import { CheckIcon } from "@heroicons/react/20/solid";
import { ArrowRightIcon, ChatBubbleBottomCenterIcon, CurrencyEuroIcon, DocumentCheckIcon, ScaleIcon } from "@heroicons/react/24/solid";
import PrendreRdv from "./prendreRdv";
import BackHeaderTop from "../components/BackHeaderTop";
import BackHeaderBottom from "../components/BackHeaderBottom";
import GoogleAvis2 from '../img/google-avis-2.png';
import MariageImg from '../img/mariage-lead.webp';
import AccompagnementClotere from '../components/AccompagnementClotere'

const posts = [
    {
        id: 1,
        title: 'Les différents régimes matrimoniaux.',
        href: 'https://clotere.fr/contrat-mariage/notaire/regimes-matrimoniaux',
        category: { title: 'Régime matrimonial mariage' },
    },
    {
        id: 2,
        title: 'Contrat de mariage idées reçues et vérités',
        href: 'https://clotere.framer.website/blog/contrat-de-mariage-id%C3%A9es-re%C3%A7ues-et-v%C3%A9rit%C3%A9s',
        category: { title: 'Contrat de mariage' },
    },
    {
        id: 3,
        title: 'Combien coûte un contrat de mariage ?',
        href: 'https://clotere.fr/outils/calculateur-frais-de-notaire-immobilier',
        category: { title: 'Prix contrat de mariage' },
    },
    {
        id: 4,
        title: 'Les étapes de votre contrat de mariage',
        href: 'https://clotere.fr/contrat-mariage/notaire/etapes-contrat-de-mariage',
        category: { title: 'Etapes contrat de mariage' },
    },
]

function Mariage(args) {
    
    return (
        <>
            <Helmet>
                <title>Contrat de mariage notaire en ligne – Simple & rapide avec Clotere</title>
                <meta name="robots" content="index,follow" />
                <meta name="googlebot" content="index,follow" />
                <meta name='description' content='Préparez votre contrat de mariage avec un notaire. Clotere vous accompagne en ligne, en toute simplicité. À partir de 369€.' />
                <meta property="og:url" content="https://clotere.fr/notaire-contrat-mariage" />
                <meta property="og:site_name" content="Clotere" />
                <meta property="og:image" content="https://clotere.fr/facebook-share-webp" />
                <meta property="og:type" content="website" />
            </Helmet>


            {/**header 2 */}
            <div className="relative rounded-4xl ">
                <BackHeaderTop />
                <Navbar user={args.user} />

                <div className="relative container ">

                    <header class="flex flex-row flex-wrap justify-center sm:py-10 items-center">
                        <div className="w-full sm:basis-1/2 p-3 sm:p-4 flex flex-col sm:gap-6 text-center">
                            <h1 className="font-medium text-transparent sm:!text-[60px] tracking-[0]  mb-0" >
                                <span className=" text-black">Un notaire à votre écoute, pour  <span className="font-bold mt-2 text-indigo-800">votre contrat de mariage</span> </span>
                            </h1>

                            <p className="text-lg font-semibold leading-7 sm:w-[80%] mb-0 mx-auto">
                                Clotere vous connecte à un notaire et vous accompagne de A à Z, pour votre contrat de mariage. C'est simple, rapide et transparent.
                            </p>

                            {/** old check 
                                        <div className="flex flex-column justify-start gap-3">
                                            <div className="flex items-center gap-2 relative flex-[0_0_auto]">
                                                
                                                <div className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-black text-md tracking-[0] leading-[normal]">
                                                    <p className="m-0 text-lg"><b className="text-indigo-800">Simple</b> : quelques informations suffisent pour démarrer votre projet.</p>
                                                </div>
                                            </div>
                                            <div className="flex items-center  gap-2 relative flex-[0_0_auto]">
                                                
                                                <div className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-black text-md tracking-[0] leading-[normal]">
                                                    <p className="m-0 text-lg"><b className="text-indigo-800">Rapide</b> : votre notaire prends en charge votre dossier rapidement.</p>
                                                </div>
                                            </div>
                                            <div className="flex items-center  gap-2 relative flex-[0_0_auto]">
                                                
                                                <div className="relative w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-normal text-black text-md tracking-[0] leading-[normal]">
                                                    <p className="m-0 text-lg"><b className="text-indigo-800">Sûr</b> : déposez dans votre espace sécurisé les documents nécessaires.</p>
                                                </div>
                                            </div>
                                        </div>
                                        */}

                            {/** bloc bouton */}
                            <div>
                                <Link to="/onboard/mariage"
                                    type="button"
                                    className=" box-content mt-3 no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-3.5 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Débuter mon contrat de mariage
                                    <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                                </Link>
                                <div className="flex flex-row gap-4 items-center mt-2 justify-center">
                                    <div className="flex flex-row gap-1 items-center text-xs">
                                        <CheckIcon className="size-4 flex" />
                                        5 minutes
                                    </div>
                                    <div className="flex flex-row gap-1 items-center text-xs">
                                        <CheckIcon className="size-4" />
                                        1er rdv gratuit
                                    </div>
                                </div>
                            </div>

                            {/**bloc avis */}
                            <div>
                                <div className="flex gap-2 items-center  justify-center">
                                    <img src={GoogleAvis2} className="w-32" alt="Notaire en ligne pour contrat de mariage avec Clotere" />
                                    <p className="m-0 text-sm font-bold">5 | <a target="blank" href="https://www.google.com/search?sca_esv=d214253f9e079b85&hl=fr&authuser=0&q=Clotere&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzZDzCaQ6PPw1Mgvvzif6RPDbzlyvfgpBpItJUodOtpKTPaOfRqxPnJiVlFGA37fDf9TtdoQ%3D&uds=ABqPDvysoTTq_vp6PiQY3u-nn8x5mrrThE-WixzhGgTgcP_mlCE3-A4gQLqOtz9y4LiiTIbfFBKkE3gMtki_Kkb4BD_mskaVaRvCLgFEWxykHDgiwrX4QIM&sa=X&ved=2ahUKEwjSoubx5s2MAxUaTqQEHXPXOdUQ3PALegQIGhAE&biw=1511&bih=765&dpr=2" className="text-black !font-normal">8 avis</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="w-full sm:basis-1/2 p-0 lg:p-5  sm:flex bg-yellow-500 overflow-hidden rounded-2xl">
                            <img className="object-cover" src={MariageImg} alt="Vos démarches chez le notaire pour votre contrat de mariage" />

                        </div>
                    </header>
                </div>
                <BackHeaderBottom />
                {/** bloc ccm */}
                <section className="">
                    <div className="container">
                        <div className="py-12">
                            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-4 sm:gap-y-16 lg:max-w-none lg:grid-cols-4 justify-center">
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <ChatBubbleBottomCenterIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Parlez avec votre notaire gratuitement</p>
                                        <p className=" text-base mb-0">Discutez avec votre notaire du meilleur régime matrimonial pour votre couple</p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <CurrencyEuroIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Un prix fixe sans surprise</p>
                                        <p className=" text-base mb-0">Le tarif d'un contrat de mariage est défini par le notaire selon votre situation. À partir de 369 € </p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <DocumentCheckIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Constituez votre dossier en ligne</p>
                                        <p className=" text-base mb-0">Ajoutez vos documents et infos depuis votre espace client Clotere.</p>

                                    </dd>
                                </div>
                                <div className="flex flex-row sm:flex-col gap-3">
                                    <dt className="text-[30px] font-semibold leading-7 text-gray-900">
                                        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-indigo-500">
                                            <ScaleIcon className="h-4 w-4 text-white" />
                                        </div>

                                    </dt>
                                    <dd className="flex flex-auto flex-col text-base leading-7 text-gray-600">
                                        <p className=" text-[20px] font-bold mb-0">Signez quand vous êtes prêts</p>
                                        <p className=" text-base mb-0">Choisissez une date et signez en ligne ou en présentiel.</p>

                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </section>

                <AccompagnementClotere/>

            </div>
            <FaqMariage />
            {/** section Blog */}
            <section class=" mt-4 mb-4 flex flex-row flex-wrap justify-center items-center">
                <div className="bg-white  sm:py-20 ">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto text-center">
                            <h2 className="title-clotere">Bien comprendre votre passage chez le notaire pour <span className="font-bold text-indigo-800">votre contrat de mariage</span></h2>

                        </div>
                        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-4 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-4 ">
                            {posts.map((post) => (
                                <article key={post.id} className="flex flex-col items-start gap-2 sm:gap-8 justify-center overflow-hidden bg-white shadow rounded-lg p-3">
                                    <p className="font-bold text-indigo-600 hover:bg-gray-100 m-0">{post.category.title} </p>

                                    <h3 className="mt-3 text-xl  font-semibold leading-7 text-gray-900 group-hover:text-gray-600">


                                        {post.title}

                                    </h3>

                                    <a href={post.href} target='blank' className="btn-primary no-underline">Lire l'article</a>

                                </article>
                            ))}
                        </div>
                        <div className="mx-auto max-w-2xl text-center">
                            <Link to="blog/notaire-et-mariage"
                                type="button"
                                className="mt-5 no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-3.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Consultez nos fiches pratiques notaire et contrat de mariage
                                <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                            </Link>
                        </div>


                    </div>

                </div>

            </section>
            <PrendreRdv />
            <Footer />
        </>
    );
}

export default Mariage;